(function () {
  if (window.__atomicWishlistToastBound) return;
  window.__atomicWishlistToastBound = true;

  const TOAST_MS = 2400;
  const TOAST_ID = 'ProductCardWishlistToast';
  const TOAST_VISIBLE_CLASS = 'is-visible';

  const hideToast = () => {
    const toast = document.getElementById(TOAST_ID);
    if (!toast) return;

    toast.classList.remove(TOAST_VISIBLE_CLASS);
    toast.setAttribute('aria-hidden', 'true');
    clearTimeout(window.__atomicWishlistToastTimer);
  };

  const openWishlistDrawer = () => {
    const drawer = document.getElementById('WishlistDrawer');

    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    const opener = document.querySelector('[data-drawer-open="WishlistDrawer"]');
    if (opener instanceof HTMLElement) {
      opener.click();
    }
  };

  const showToast = () => {
    const toast = document.getElementById(TOAST_ID);
    if (!toast) return;

    toast.classList.remove(TOAST_VISIBLE_CLASS);
    void toast.offsetWidth;
    toast.classList.add(TOAST_VISIBLE_CLASS);
    toast.setAttribute('aria-hidden', 'false');

    clearTimeout(window.__atomicWishlistToastTimer);
    window.__atomicWishlistToastTimer = setTimeout(() => {
      toast.classList.remove(TOAST_VISIBLE_CLASS);
      toast.setAttribute('aria-hidden', 'true');
    }, TOAST_MS);
    // Auto-hide countdown sweep over the black button pill (AAS-1166).
    window.toastProgress?.(toast, TOAST_MS, '.product-card__wishlist-toast-button');
  };

  document.addEventListener('DOMContentLoaded', () => {
    const toast = document.getElementById(TOAST_ID);
    if (!toast) return;
    const button = toast.querySelector('.product-card__wishlist-toast-button');
    if (button) {
      button.addEventListener('click', () => {
        hideToast();
        openWishlistDrawer();
      });
    }
  });

  document.addEventListener(
    'click',
    (event) => {
      const btn = event.target && event.target.closest
        ? event.target.closest('.product-card__wishlist-btn[data-wishlist-toggle], .card-product__mobile-actions-btn--wishlist[data-wishlist-toggle]')
        : null;
      if (!btn) return;

      const wasOn = btn.classList.contains('is-wishlisted') || btn.getAttribute('aria-pressed') === 'true';
      if (wasOn) return;

      let attempts = 0;
      const poll = setInterval(() => {
        attempts += 1;
        const isOn = btn.classList.contains('is-wishlisted') || btn.getAttribute('aria-pressed') === 'true';

        if (isOn) {
          clearInterval(poll);
          showToast();
        } else if (attempts > 20) {
          clearInterval(poll);
        }
      }, 60);
    },
    true
  );
})();
